export default __webpack_public_path__ + "static/media/logo_text_dark.948a68bb.svg";